import React, { useMemo } from "react";
import { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import Modal from "react-modal";
import {
  Modal as AntdModal,
  Button,
  Form,
  Input,
  Space,
  Typography,
  message,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config";
import S3 from "react-aws-s3";
import { RiCloseFill, RiDeleteBin6Line, RiEditLine } from "react-icons/ri";
import "../../styles/addCategories.css";
import { difference } from "lodash";
import {
  Card,
  Button as AntdButton,
  Popconfirm,
  theme,
  Image,
  Dropdown,
} from "antd";
import CustomTable from "../table";
import {
  EllipsisOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import FileUpload from "../commons/fileUpload";
import { useAccess } from "../../provider/AccessProvider";
import { CATEGORYACCESS } from "../../utils/constant";
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  SortableContext,
  arrayMove,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { v4 } from "uuid";

const Row = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    ...rest
  } = useSortable({
    id: props["data-row-key"],
  });
  const style = {
    ...props.style,
    transform: CSS.Transform.toString(
      transform && {
        ...transform,
        scaleY: 1,
      }
    ),
    transition,
    ...(isDragging
      ? {
          position: "relative",
          zIndex: 9999,
        }
      : {}),
  };
  console.log("rest111", rest);
  return (
    <tr
      {...props}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    />
  );
};

const convertCategoryObjToArray = (obj) => {
  const result = Object.keys(obj).map((i) => {
    const categoryId = v4();
    return {
      category: i,
      subCategories:
        obj[i].subCategory?.length > 0 ? obj[i].subCategory : ["others"],
      imageUrl: obj[i].imageUrl ? obj[i].imageUrl : "",
      key: categoryId,
      rank: obj[i].rank,
      originalData: obj[i],
    };
  });
  result.sort((a, b) => {
    return a.originalData?.rank - b.originalData?.rank;
  });
  console.log("result", result);
  return result;
};

export default function AddCategories(props) {
  const {
    token: { colorPrimary, colorTextSecondary },
  } = theme.useToken();
  const shopDetails = useSelector((state) => state.shopDetails);
  const [addNewCategoryModal, setAddNewCategoryModal] = useState(false);
  const [initialValue, setInitialValue] = useState({});
  const [fetchedCategoryList, setFetchedCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const access = useAccess(CATEGORYACCESS);
  const [mode, setMode] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const categoryApi = `${config.newApiGateway}/products/dashboard-products-categories`;
  const [reOrderDisable, setReOrderDisable] = useState(true);
  const getExistingCategories = async () => {
    const requestBody = JSON.stringify({
      action: "getCategoryList",

      shopId: shopDetails.shopId,
    });
    try {
      await fetch(categoryApi, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: requestBody,
      })
        .then((data) => data.json())
        .then((data) => {
          if (data.categoryList) {
            const categoryList = convertCategoryObjToArray(data.categoryList);
            setFetchedCategoryList(categoryList);
            dispatch({
              type: "SET_SHOP_PROFILE_CATEGORY",
              payload: data.categoryList,
            });
          }
        });
    } catch (err) {
      console.error("error", err);
    } finally {
      setLoading(false);
    }
  };

  const deleteCategory = async (name) => {
    let alertText = `Confirm to delete, all product under category ${name} wil be moved to others category.`;
    if (window.confirm(alertText)) {
      const tempObj = {};
      fetchedCategoryList.forEach((i) => {
        tempObj[i.category] = {
          ...i.originalData,
          rank: i.originalData.rank,
        };
      });
      delete tempObj[name];
      const tempCategories = {};
      Object.keys(tempObj).forEach((i, index) => {
        tempCategories[i] = {
          ...tempObj[i],
          rank: index + 1,
        };
      });
      try {
        await fetch(categoryApi, {
          method: "post",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updatedCategory: tempObj,
            newCode: true,
            action: "deleteCategory",
            shopId: shopDetails.shopId,
            deleteCategory: name,
          }),
        })
          .then((data) => data.json())
          .then((data) => {
            if (data.code == "200" && data.status == "Success") {
              message.success("Category Deleted Successfully");
              setSelectedCategory({});
              const categoryList = convertCategoryObjToArray(
                data.updatedCategoryList
              );
              setFetchedCategoryList(categoryList);
              dispatch({
                type: "SET_SHOP_PROFILE_CATEGORY",
                payload: data.updatedCategoryList,
              });
            }
          });
      } catch (err) {
        console.error("error deleting category", err);
      } finally {
        setLoading(false);
      }
    }
  };
  const addNewCategory = async (updateCategory) => {
    try {
      await fetch(categoryApi, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          updatedCategory: updateCategory,
          action: "addNewCategory",
          newCode: true,
        }),
      })
        .then((data) => data.json())
        .then((data) => {
          if (data.code == "200" && data.status == "Success") {
            message.success("Category Added Successfully");
            const categoryList = convertCategoryObjToArray(
              data.updatedCategoryList
            );
            setFetchedCategoryList(categoryList);
            dispatch({
              type: "SET_SHOP_PROFILE_CATEGORY",
              payload: data.updatedCategoryList,
            });
            form.resetFields();
          }
        });
    } catch (err) {
      console.error("error adding new category", err);
    } finally {
      setLoading(false);
      setAddNewCategoryModal(false);
    }
  };

  const editCategory = async (updateCategory, formValues) => {
    try {
      const deletedSubCategorires = difference(
        initialValue.subCategory,
        formValues.subCategory
      );
      await fetch(categoryApi, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          updatedCategory: updateCategory,
          action: "editCategory",
          newCode: true,
          newCategoryName: formValues.category,
          editCategory: initialValue.category,
          deletedSubCategories: deletedSubCategorires,
        }),
      })
        .then((data) => data.json())
        .then((data) => {
          if (data.code == "200" && data.status == "Success") {
            message.success("Category Updated Successfully");
            const categoryList = convertCategoryObjToArray(
              data.updatedCategoryList
            );
            setFetchedCategoryList(categoryList);
            dispatch({
              type: "SET_SHOP_PROFILE_CATEGORY",
              payload: data.updatedCategoryList,
            });
            form.resetFields();
          }
        });
    } catch (err) {
      console.error("error adding new category", err);
    } finally {
      setLoading(false);
      setAddNewCategoryModal(false);
    }
  };

  const reOrderCategory = async (updateCategory) => {
    setLoading(true);
    try {
      await fetch(categoryApi, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          updatedCategory: updateCategory,
          action: "addNewCategory",
          newCode: true,
        }),
      })
        .then((data) => data.json())
        .then((data) => {
          if (data.code == "200" && data.status == "Success") {
            message.success("Category Updated Successfully");
            const categoryList = convertCategoryObjToArray(
              data.updatedCategoryList
            );
            setFetchedCategoryList(categoryList);
            dispatch({
              type: "SET_SHOP_PROFILE_CATEGORY",
              payload: data.updatedCategoryList,
            });
            form.resetFields();
          }
          setReOrderDisable(true);
        });
    } catch (err) {
      console.error("error adding new category", err);
    } finally {
      setLoading(false);
      setAddNewCategoryModal(false);
      setReOrderDisable(true);
    }
  };

  const defaultImg =
    "https://ghoshak-website-builder.s3.ap-south-1.amazonaws.com/defaultImage.png";

  const handleEdit = (name) => {
    const editCategory = fetchedCategoryList.find((i) => i.category === name);
    setAddNewCategoryModal(true);
    setMode("edit");
    setInitialValue({
      category: name,
      subCategory: editCategory.subCategories,
      rank: editCategory.rank,
      images: editCategory.imageUrl
        ? [
            {
              id: "1",
              url: editCategory.imageUrl ? editCategory.imageUrl : defaultImg,
              name: "Category Image",
            },
          ]
        : [],
    });
  };

  const menuItems = (rowData) => {
    const isDeleteAccess = access.deleteCategory(false);

    const result = [
      {
        key: "1",
        icon: <RiDeleteBin6Line color={colorPrimary} />,
        label: isDeleteAccess ? (
          <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this Category?"
            onConfirm={() => deleteCategory(rowData.category)}
            onCancel={() => {}}
            okText={"Yes"}
            cancelText={"No"}
          >
            <span
              style={{
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
                color: colorPrimary,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Delete
            </span>
          </Popconfirm>
        ) : (
          <span
            role="button"
            onClick={() => {
              access.deleteCategory();
            }}
            style={{
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 4,
              color: colorPrimary,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Delete
          </span>
        ),
        style: {
          width: 100,
        },
      },
      {
        key: "2",
        icon: <RiEditLine color={colorTextSecondary} />,
        style: {
          width: 100,
        },
        label: (
          <span
            style={{
              fontSize: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              gap: 4,
              color: colorTextSecondary,
              fontWeight: 600,
            }}
            role="button"
            onClick={() => {
              const isAccess = access.editCategory();
              if (!isAccess) {
                return;
              }
              handleEdit(rowData.category);
            }}
          >
            Edit
          </span>
        ),
      },
    ];
    return rowData.category.toUpperCase() !== "OTHERS"
      ? result
      : result.slice(1, 2);
  };

  const categoryTableColumns = [
    {
      title: "Category",
      width: "20%",
      render: (rowData) => {
        return (
          <div>
            <Image
              style={{
                width: "80px",
                height: "80px",
                borderRadius: 8,
                objectFit: "cover",
              }}
              fallback="https://ghoshak-website-builder.s3.ap-south-1.amazonaws.com/defaultImage.png"
              src={rowData.imageUrl}
              alt={rowData.category}
            />
            <span
              style={{
                marginLeft: 10,
              }}
            >
              {rowData.category}
            </span>
          </div>
        );
      },
    },
    {
      title: "Sub Categories",
      render: (rowData) => {
        const formatter = new Intl.ListFormat("en", {
          style: "long",
          type: "conjunction",
        });
        return (
          <div
            style={{
              textTransform: "uppercase",
            }}
          >
            {formatter.format(rowData.subCategories)}
          </div>
        );
      },
    },
    {
      title: "Action",
      width: "30%",
      render: (rowData) => {
        return (
          <Dropdown
            getPopupContainer={(el) => el.parentNode}
            menu={{ items: menuItems(rowData) }}
            placement="left"
            arrow
          >
            <EllipsisOutlined
              style={{
                fontSize: "2rem",
                transform: "rotate(90deg)",
                cursor: "pointer",
                padding: "0.5rem",
              }}
            />
          </Dropdown>
        );
      },
    },
  ];
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e;
  };

  const handleFormSubmit = (values) => {
    let subCategory = [];
    let images = [];
    if (values.images) {
      images = values.images;
    }
    if (values.subCategory) {
      subCategory = values.subCategory.map((i) => i.toLowerCase());
    }
    const categories = {};
    fetchedCategoryList.forEach((i, index) => {
      categories[i.category] = {
        ...i.originalData,
        rank: index + 1,
      };
    });
    delete categories[initialValue.category];
    let updateCategory = {
      ...categories,
      [values.category.toUpperCase()]: {
        subCategory: subCategory.includes("others")
          ? subCategory
          : [...subCategory, "others"],
        rank:
          mode === "edit" ? initialValue.rank : fetchedCategoryList.length + 1,
        imageUrl: images.length > 0 ? images[0].url : "",
      },
    };
    mode === "edit"
      ? editCategory(updateCategory, values)
      : addNewCategory(updateCategory);
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        // https://docs.dndkit.com/api-documentation/sensors/pointer#activation-constraints
        distance: 1,
      },
    })
  );
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      const activeIndex = fetchedCategoryList.findIndex((i) => {
        return i.key === active.id;
      });
      const overIndex = fetchedCategoryList.findIndex(
        (i) => i.key === over?.id
      );
      const data = arrayMove(fetchedCategoryList, activeIndex, overIndex);
      const updatingRank = data.map((i, index) => {
        return {
          ...i,
          rank: index + 1,
        };
      });

      setFetchedCategoryList(updatingRank);
    }
  };

  const handleReOrderSubmit = () => {
    const categories = {};
    fetchedCategoryList.forEach((i) => {
      categories[i.category] = {
        ...i.originalData,
        rank: i.rank,
      };
    });
    reOrderCategory(categories);
  };

  useEffect(() => {
    if (shopDetails.shopId) {
      getExistingCategories();
    }
  }, [shopDetails.shopId]);

  useEffect(() => {
    if (mode === "edit") {
      form.setFieldsValue(initialValue);
    }
  }, [mode, initialValue]);
  return (
    <div>
      <div>
        <Card
          style={{
            boxShadow: "none",
            border: 0,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              textAlign: "right",
            }}
          >
            {!reOrderDisable && (
              <>
                <div>
                  <AntdButton
                    type="primary"
                    onClick={() => {
                      setReOrderDisable(true);
                    }}
                    style={{
                      marginRight: 8,
                    }}
                    ghost
                  >
                    Cancel
                  </AntdButton>

                  <AntdButton
                    type="primary"
                    onClick={handleReOrderSubmit}
                    style={{
                      marginRight: 8,
                    }}
                  >
                    Submit
                  </AntdButton>
                </div>
              </>
            )}
            {reOrderDisable && (
              <>
                <AntdButton
                  type="primary"
                  onClick={() => {
                    setReOrderDisable(false);
                  }}
                  style={{
                    marginRight: 8,
                  }}
                >
                  Re-order
                </AntdButton>
                <AntdButton
                  type="primary"
                  onClick={() => {
                    const isAccess = access.createCategory();
                    if (!isAccess) {
                      return;
                    }
                    setAddNewCategoryModal(true);
                    setMode("add");
                  }}
                >
                  Add Category
                </AntdButton>
              </>
            )}
          </div>
        </Card>

        <DndContext
          sensors={sensors}
          modifiers={[restrictToVerticalAxis]}
          onDragEnd={onDragEnd}
        >
          <SortableContext
            // rowKey array
            items={fetchedCategoryList.map((i) => i.key)}
            strategy={verticalListSortingStrategy}
            disabled={reOrderDisable}
          >
            <CustomTable
              components={{
                body: {
                  row: Row,
                  // row: (props) => (
                  //   <Row {...props} dragDisabled={reOrderDisable} />
                  // ),
                },
              }}
              rowKey="key"
              columns={categoryTableColumns}
              loading={loading}
              data={fetchedCategoryList}
              title={"Categories"}
              pagination={reOrderDisable ? true : false}
              rowClassName={
                reOrderDisable ? "initial-cursor" : "row-drag-cursor"
              }
            />
          </SortableContext>
        </DndContext>

        <AntdModal
          footer={false}
          centered
          open={addNewCategoryModal}
          onCancel={() => {
            setAddNewCategoryModal(false);
            setInitialValue({});
            form.resetFields();
          }}
        >
          <Typography.Title level={4}>
            {mode === "edit" ? "Edit" : "Create"} Category
          </Typography.Title>
          <Form
            onFinish={handleFormSubmit}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            form={form}
          >
            <Form.Item
              style={{
                marginBottom: 10,
              }}
              label="Category"
              name={"category"}
              rules={[
                {
                  required: true,
                  message: "Enter category!",
                },
                {
                  validator: async (_, names) => {
                    if (names) {
                      const categoryKey = fetchedCategoryList;
                      const isExist = categoryKey
                        .map((i) => i.category.toUpperCase())
                        .includes(names.toUpperCase());
                      if (
                        mode === "edit" &&
                        isExist &&
                        names.toUpperCase() !== initialValue.category
                      ) {
                        return Promise.reject(
                          new Error("Category already exist!!")
                        );
                      } else if (mode === "add" && isExist) {
                        return Promise.reject(
                          new Error("Category already exist!!")
                        );
                      }
                    }
                  },
                },
                {
                  validator: async (_, names) => {
                    if (names && mode === "edit") {
                      return Promise.reject(
                        new Error(
                          "All product under this category wil be moved to Renamed category!!!."
                        )
                      );
                    }
                  },
                  warningOnly: true,
                },
              ]}
            >
              <Input
                disabled={
                  form.getFieldValue("category")?.toUpperCase() === "OTHERS"
                }
                placeholder="Enter Category"
              />
            </Form.Item>
            <Form.Item
              style={{
                marginBottom: 0,
              }}
              label="Sub Category"
            >
              <Form.List
                name="subCategory"
                // rules={[
                //   {
                //     validator: async (_, names) => {
                //       if (!names || names.length < 1) {
                //         return Promise.reject(
                //           new Error("At least 1 subcategory")
                //         );
                //       }
                //     },
                //   },
                // ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item required={false} key={field.key}>
                        <Form.Item
                          {...field}
                          validateTrigger={["onChange", "onBlur"]}
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: "Enter subcategory!",
                            },
                            {
                              validator: async (_, names) => {
                                if (names) {
                                  let subCategories = [
                                    ...form.getFieldValue("subCategory"),
                                  ];
                                  if (subCategories.length) {
                                    subCategories = subCategories
                                      .toSpliced(index, 1)
                                      .map((i) => i?.toLowerCase());
                                  }
                                  const isExist = subCategories.includes(
                                    names.toLowerCase()
                                  );
                                  if (isExist) {
                                    return Promise.reject(
                                      new Error("Sub Category already exist!!")
                                    );
                                  }
                                }
                              },
                            },
                          ]}
                          noStyle
                        >
                          <Input
                            placeholder="Enter Subcategory"
                            style={{ width: "94%" }}
                            disabled={
                              form
                                .getFieldValue(["subCategory", index])
                                ?.toLowerCase() === "others"
                            }
                          />
                        </Form.Item>
                        {fields.length > 1 &&
                        form
                          .getFieldValue(["subCategory", index])
                          ?.toLowerCase() !== "others" ? (
                          <MinusCircleOutlined
                            style={{
                              fontSize: 20,
                              position: "relative",
                              top: 4,
                              left: 12,
                            }}
                            onClick={() => remove(field.name)}
                          />
                        ) : null}
                      </Form.Item>
                    ))}

                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        style={{ width: "100%" }}
                      >
                        <Space direction="horizontal">
                          <PlusOutlined /> Add Sub category
                        </Space>
                      </Button>
                      <Form.ErrorList errors={errors} />
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>
            <Form.Item
              label="Category Image"
              name={"images"}
              getValueFromEvent={normFile}
            >
              <FileUpload maxCount={1} />
            </Form.Item>
            <Form.Item
              style={{
                marginBottom: 0,
              }}
            >
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Button
                  style={{ width: 100, marginRight: 16 }}
                  type="primary"
                  ghost
                  onClick={function handleBack() {
                    form.resetFields();
                    setAddNewCategoryModal(false);
                  }}
                >
                  Back
                </Button>
                <Button htmlType="submit" style={{ width: 100 }} type="primary">
                  Submit
                </Button>
              </div>
            </Form.Item>
          </Form>
        </AntdModal>
      </div>
    </div>
  );
}
